export const getDelayValueFromRange = (
  delayRange: [number] | [number, number]
): number => {
  const [minDelay, maxDelay] = delayRange;
  if (!maxDelay) return minDelay;
  return Math.floor(Math.random() * (maxDelay - minDelay + 1)) + minDelay;
};
